import React from 'react';
import { HardDrive, Zap, TrendingUp } from 'lucide-react';
type StorageWidgetProps = {
  storageUsed: number;
  storageTotal: number;
  creditsRemaining: number;
};
export function StorageWidget({
  storageUsed,
  storageTotal,
  creditsRemaining
}: StorageWidgetProps) {
  const storagePercentage = storageUsed / storageTotal * 100;
  return <div className="px-4 py-3 border-t border-gray-200" data-id="element-1792">
      <div className="space-y-3" data-id="element-1793">
        {/* Storage */}
        <div data-id="element-1794">
          <div className="flex items-center justify-between mb-2" data-id="element-1795">
            <div className="flex items-center gap-2" data-id="element-1796">
              <HardDrive className="w-4 h-4 text-gray-500" data-id="element-1797" />
              <span className="text-xs font-medium text-gray-600" data-id="element-1798">Storage</span>
            </div>
            <span className="text-xs text-gray-600" data-id="element-1799">
              {storageUsed}/{storageTotal} GB
            </span>
          </div>
          <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-1800">
            <div className="h-full bg-gradient-to-r from-green-500 to-green-600 rounded-full transition-all duration-300" style={{
            width: `${storagePercentage}%`
          }} data-id="element-1801" />
          </div>
        </div>

        {/* Credits */}
        <div data-id="element-1802">
          <div className="flex items-center justify-between" data-id="element-1803">
            <div className="flex items-center gap-2" data-id="element-1804">
              <Zap className="w-4 h-4 text-amber-500" data-id="element-1805" />
              <span className="text-xs font-medium text-gray-600" data-id="element-1806">Credits</span>
            </div>
            <span className="text-xs font-semibold text-gray-900" data-id="element-1807">
              {creditsRemaining}
            </span>
          </div>
        </div>

        {/* Upgrade Link */}
        <button className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-gradient-to-r from-green-500 to-green-600 text-white text-xs font-medium rounded-lg hover:from-green-600 hover:to-green-700 transition-all shadow-sm" data-id="element-1808">
          <TrendingUp className="w-3.5 h-3.5" data-id="element-1809" />
          Upgrade Plan
        </button>
      </div>
    </div>;
}